<template>
    <form ref="form" @submit="handleUpdateProfile" novalidate>
        <div class="modal-dialog" style="min-width: 400px">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Profile</h5>
                </div>
                <div class="modal-body">
                    <div class="alert alert-danger" v-if="errorMessage">
                        {{errorMessage}}
                    </div>
                    <div class="alert alert-danger" v-if="errorDetails">                        
                        <ul id="error-details">
                            <li v-for="detail in errorDetails.split(',')" :key="detail">
                                {{ detail }}
                            </li>
                        </ul>
                    </div>
                    <div class="alert alert-success" v-if="successMessage">
                        {{successMessage}}
                    </div>
                    <div class="form-group mb-2">
                        <div class="row">
                            <div class="col">
                                <label for="firstName" class="form-label">Your Name: <alzata-required-indicator /></label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input type="text"
                                    class="form-control"
                                    placeholder="First"
                                    v-model="firstName"
                                    ref="firstName"
                                    required
                                    :disabled="busy"
                                    data-lpignore="true"
                                    />
                            </div>
                            <div class="col">
                                <input type="text"
                                    class="form-control"
                                    placeholder="Last"
                                    v-model="lastName"
                                    ref="lastName"
                                    required
                                    :disabled="busy"
                                    data-lpignore="true"
                                    />
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-2">
                        <div class="row">
                            <div class="col">
                                <label for="email" class="form-label">Email Address: <alzata-required-indicator /></label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input type="text"
                                    class="form-control"
                                    v-model="email"
                                    required
                                    :disabled="busy"
                                    data-lpignore="true"
                                    />
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-2">
                        <div class="row">
                            <div class="col">
                                <label for="phone" class="form-label">Phone Number: <alzata-required-indicator /></label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input type="text"
                                    class="form-control"
                                    v-model="phoneNumber"
                                    required
                                    :disabled="busy"
                                    data-lpignore="true"
                                    />
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-2">
                        <div class="row">
                            <div class="col">
                                <label for="phone" class="form-label">Username: <alzata-required-indicator /></label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input type="text"
                                    class="form-control"
                                    v-model="username"
                                    required
                                    :disabled="busy"
                                    data-lpignore="true"
                                    />
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                      <button type="button" class="btn btn-link" @click="handleCancel">Cancel</button>
                      <button type="submit" class="btn btn-primary text-center" :disabled="busy">{{busy ? 'Updating Profile...' : 'Update Profile'}}</button>
                    </div>
                </div>                
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'AlzataProfile',
    data: () => ({
        userId: null,
        name: {
            first: '',
            last: '',
        },
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        username: '',        
        errorMessage: null,
        errorDetails: null,
        successMessage: null,
        busy: false,
        formWasValidated: false,
    }),
    async mounted() {
        this.$refs.firstName.focus();
        const result = await this.apiClient.getProfile();  
        if (result.id) {
          this.userId = result.id;
          this.firstName = result.firstName;
          this.lastName = result.lastName;
          this.email = result.email;
          this.phoneNumber = result.phoneNumber;
          this.username = result.userName;
        } else {
          this.errorMessage = 'Error loading profile.';
        }
    },
    methods: {
        async handleUpdateProfile(evt) {
            evt.preventDefault();
            this.errorMessage = null;
            this.errorDetails = null;
            this.busy = true;
            try {
                const result = await this.apiClient.updateProfile(this.userId, this.username, this.firstName, this.lastName, this.email, this.phoneNumber);                
                if (result.id) {
                    this.successMessage = 'Profile Updated.';
                    window.setTimeout(() => this.$router.back(), 1000);
                }
                else {
                    this.errorMessage = 'Failed to Update Profile.';
                    this.errorDetails = result.displayMessage;
                    window.setTimeout(() => this.$refs.firstName.focus(), 0);
                }
            }
            finally {
                this.busy = false;
            }
        },
        handleCancel() {
          this.$router.back();
        }
    },
};
</script>